import { Column } from "@/components/Column";
import { Text } from "@/components/Text";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@ui/select";

import { sadieDashboardRangeToLabel } from "@/lib/constants";
import { SadieDashboardRange } from "@/types";

const RANGES = Object.values(SadieDashboardRange);

const isRange = (value: string): value is SadieDashboardRange =>
  (RANGES as string[]).includes(value);

export const SadieDashboardRangeSelect = ({
  range,
  setRange,
}: {
  range: SadieDashboardRange;
  setRange: (range: SadieDashboardRange) => void;
}) => {
  /* Handlers */
  const handleValueChange = (value: string) => {
    if (isRange(value)) setRange(value);
  };

  /* Render */
  return (
    <Column className="gap-1">
      <Text className="text-xs font-medium text-slate-500">Date range</Text>
      <Select value={range} onValueChange={handleValueChange}>
        <SelectTrigger className="h-9 w-[160px] bg-white">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {RANGES.map((option) => (
            <SelectItem key={option} value={option}>
              {sadieDashboardRangeToLabel[option]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Column>
  );
};
